import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditGamaComponent } from './edit-gama/edit-gama.component';
import { PrintComponent } from './print/print.component';

const routes: Routes = [
  {
    path: ':action/:param_id',
    component: EditGamaComponent,
  },
  {
    path: 'print',
    component: PrintComponent,
  },
  { path: '', redirectTo: '', pathMatch: 'full' },
  { path: '**', redirectTo: '/orders', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GamasRoutingModule {}
